import {isUndefined} from 'lodash';
import {createSelector} from 'reselect';

import {AppParametricSelector, AppSelector} from '../../../helpers/reselectHelpers';
import {CommentComposerState} from './commentComposerState';

/*
 * Selectors.
 */

export const getCommentComposerState: AppSelector<CommentComposerState> = (state) =>
  state.metadata.commentComposer;

export function makeGetIsCommentComposerExpanded<P>(
  getCommentUid: AppParametricSelector<P, string | undefined>,
  defaultResult = false,
): AppParametricSelector<P, boolean> {
  return createSelector([getCommentComposerState, getCommentUid], (state, uid) => {
    if (isUndefined(uid)) {
      return defaultResult;
    }

    return state.expandedCommentUids.includes(uid);
  });
}
